import { Pipe, PipeTransform } from '@angular/core';
import { Regiao } from '../../modelos/regiao';

@Pipe({
  name: 'filtroRegioes'
})
export class FiltroRegioesPipe implements PipeTransform {

  transform(regioes: Regiao[], filtro?: string): any {
    if (regioes === undefined || filtro === undefined || filtro.trim() === '') {
      return regioes;
    }
    filtro = filtro.toLocaleLowerCase();
    return regioes.filter(regiao => regiao.descricaoRegiao.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-regioes.pipe.ts